import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class ProspectGateway {
    HttpAdapter = new HttpAdapter();
    baseUrlProspect = `${publicSettings.aws.baseUrls.company}/company/prospect`;

    async getByAccountingId(accountingId) {
        try {
            const { response } = await this.HttpAdapter.call(
                `${this.baseUrlProspect}/get-by-accountingid`,
                {
                    accountingId
                }
            );

            return response;
        } catch (err) {
            console.log("err", err);
            return [];
        }
    }

    async save({ _id = null, accountingId, name, contact, variables }) {
        try {
            const input = {
                ...(_id ? { _id } : {}),
                accountingId,
                name,
                contact,
                variables
            };

            const { response } = await this.HttpAdapter.call(
                `${this.baseUrlProspect}/save`,
                input
            );

            return response;
        } catch (err) {
            console.log("err", err);
            return [];
        }
    }

    async remove(ids) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlProspect}/remove-by-ids`,
                { ids }
            );

            return response;
        } catch (err) {
            console.log("err", err);
            return [];
        }
    }

    async getById(_id) {
        if (!_id) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlProspect}/get-by-id`,
                { _id }
            );
            return response;
        } catch (err) {
            throw new Error(err?.message || "Erro ao buscar prospect");
        }
    }
}
